export default __webpack_public_path__ + "static/media/pawn_rook_bg.15c46399.png";